/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deal_Provision_Source_PercentInputs */

const cs_deal_provision_source_percent = /** @type {(inputs: Deal_Provision_Source_PercentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Z procenta`)
};

const en_deal_provision_source_percent = /** @type {(inputs: Deal_Provision_Source_PercentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From percent`)
};

/**
* | output |
* | --- |
* | "From percent" |
*
* @param {Deal_Provision_Source_PercentInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const deal_provision_source_percent = /** @type {((inputs?: Deal_Provision_Source_PercentInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deal_Provision_Source_PercentInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deal_provision_source_percent(inputs)
	return cs_deal_provision_source_percent(inputs)
});